// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"preview_wrapper__2qbUd","content":"preview_content__3zA-L","preview":"preview_preview__BAjLQ","mobileContainar":"preview_mobileContainar__X6PzN"};